import store from "store";

export const Authorizations = {
    GLOBAL_ORGANIZATION_MANAGEMENT : 'global.organization.management', // "Top-level" authorization, cannot be assigned to a Member affected to a Retailer.
    GLOBAL_ORGANIZATION_ESHOP_MANAGEMENT : 'global.organization.eshop.management', // "Top-level" authorization, cannot be assigned to a Member affected to a Retailer.
    GLOBAL_ORGANIZATION_ACCOUNTING_MANAGEMENT : 'global.organization.accounting.management',
    GLOBAL_ORGANIZATION_SUPERVISOR : 'global.organization.supervisor',
    GLOBAL_ROLE_MANAGEMENT : 'global.role.management',
    GLOBAL_MEMBER_MANAGEMENT : 'global.member.management',
    GLOBAL_PRINTNODE_NOTIFICATION : 'global.printnode.notification',
    GLOBAL_DEMO: 'global.demo',

    MARKETPLACE_RETAILER_VIEW : 'marketplace.retailer.view', // "Top-level" authorization, cannot be assigned to a Member affected to a Retailer.
    MARKETPLACE_RETAILER_MANAGEMENT : 'marketplace.retailer.management', // "Top-level" authorization, cannot be assigned to a Member affected to a Retailer.
    MARKETPLACE_FEED_MANAGEMENT : 'marketplace.feed.management',
    MARKETPLACE_OPTION_MANAGEMENT : 'marketplace.option.management',
    MARKETPLACE_ATTRIBUTES_MANAGEMENT : 'marketplace.attribute.management',
    MARKETPLACE_ATTRIBUTE_CREATION : 'marketplace.attribute.creation',
    MARKETPLACE_ATTRIBUTE_EXPORT : 'marketplace.attribute.export',
    MARKETPLACE_PRODUCT_VIEW : 'marketplace.product.view',
    MARKETPLACE_PRODUCT_EDIT : 'marketplace.product.edit',
    MARKETPLACE_PRODUCT_MANAGEMENT : 'marketplace.product.management',
    MARKETPLACE_PRODUCT_ENRICH : 'marketplace.product.enrich',
    MARKETPLACE_PHYSICALENTRY_MANAGEMENT : 'marketplace.physical_entry.management',
    MARKETPLACE_CATEGORY_MANAGEMENT: 'marketplace.category.management',
    MARKETPLACE_SHIPPING_METHODS_MANAGEMENT: 'marketplace.shipping_methods.management',
    MARKETPLACE_MERCHANDISING: 'marketplace.merchandising',
    MARKETPLACE_CANCELLATION_REASON_MANAGEMENT: 'marketplace.cancellation_reason.management',
    MARKETPLACE_OPTIN_EXPORT: 'marketplace.optin.export',
    MARKETPLACE_GUEST_EXPORT: 'marketplace.guest.export',
    MARKETPLACE_COMPLIANCE: 'marketplace.compliance',
    MARKETPLACE_ACCOUNTING : 'marketplace.accounting',

    PICKING_MANAGER : 'picking.manager', // "Top-level" authorization, cannot be assigned to a Member affected to a Retailer.
    PICKING_RUNNER : 'picking.runner', // "Top-level" authorization, cannot be assigned to a Member affected to a Retailer.
    PICKING_NOTIFICATION : 'picking.notification',
    PICKING_RETAILER : 'picking.retailer',
    PICKING_RETAILER_SHIPMENT : 'picking.retailer.shipment',
    PICKING_RETAILER_CONFIRM : 'picking.retailer.confirm',
    PICKING_RETAILER_SEND : 'picking.retailer.send',
    PICKING_RETAILER_CANCEL : 'picking.retailer.cancel',
    PICKING_RETAILER_REFUND : 'picking.retailer.refund',
    PICKING_RETAILER_RESERVE : 'picking.retailer.reserve', // reserve a pending item, nothing further
    PICKING_RETAILER_CANCEL_RESERVED : 'picking.retailer.cancel_reserved', // cancel a pending or reserved item, unlike picking.retailer.cancel which goes up to confirmed
    PICKING_RETAILER_C_C : 'picking.retailer.cc',
    PICKING_RETAILER_DRIVE : 'picking.retailer.drive',
    PICKING_READ_ONLY : 'picking.read.only',
    PICKING_RETAILER_QUOTE : 'picking.retailer.quote',
    PICKING_STATISTICS_QUOTES: 'picking.statistics.quotes',
    PICKING_RETURN_ADMIN: 'picking.return.admin',
    PICKING_RETURN_MANAGEMENT: 'picking.return.management',
    PICKING_PRINTERS: 'picking.printers',
    PICKING_HIDE_RGPD_DATA: 'picking.hide.rgpd',
    PICKING_ORDER_DETAILS: 'picking.order.details', // allow user with this authorization to see the order details (payment methods)
    PICKING_VIEW_SHIPPING_FEES: 'picking.order.shipping_fees', // allow user with this authorization to see the order shipping fees

    PERSONALSHOPPER_MANAGEMENT : 'personal_shopper.management', // "Top-level" authorization, cannot be assigned to a Member affected to a Retailer.

    STOCK_EASY_ACCESS: 'stock_easy.access', // "Top-level" authorization, can be assigned to a Member affected to a Retailer.
    STOCK_EASY_CATALOG_PRODUCT_SETTINGS: 'stock_easy.catalog.product.settings',

    STATISTICS_ACCESS: 'statistics.access',
    STATISTICS_OPE: 'statistics.ope',

    OTHER_HELPDESK_CLIENT: 'other.helpdesk.client', // change the helpdesk link in sidebar
    OTHER_HELPDESK_MERCHAND: 'other.helpdesk.merchand', // default helpdesk link in sidebar
    OTHER_RETAILER_PROFILE: 'other.retailer.profile',

    WMS_ACCESS: 'wms.access',
    WMS_MANAGER: 'wms.manager',
    WMS_DECLARE_UNAVAILABLE: 'wms.declare.unavailable',

    API_RETAILER_FEED: 'api.retailer.feed',
    API_MCP: 'api.mcp',
}

export const Applications = {
    GLOBAL: 'global',
    MARKETPLACE: 'marketplace',
    PICKING: 'picking',
    PERSONAL_SHOPPER: 'personal_shopper',
    STOCK_EASY: 'stock_easy',
    STATISTICS: 'statistics',
    OTHER: 'other',
    WMS: 'wms',
    API: 'api'
}

export function hasAuthorization(authorizations, authorization) {
    if (!authorizations) return false;

    return authorizations.includes(authorization);
}

export function currentUserHasAuthorization(authorization) {
    return hasAuthorization(store.getState().authentication?.authorizations, authorization);
}

// Batch actions and the inline ranking edit on the product / variation lists
// are reserved to users who can actually edit products.
export function hasProductEditionAuthorization(authorizations) {
    return hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT)
        || hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_EDIT)
        || hasAuthorization(authorizations, Authorizations.STOCK_EASY_ACCESS);
}

export function hasApplicationAuthorization(authorizations, application) {
    return authorizations.find(authorization => authorization.startsWith(application));
}

export function initApplicationAuthorizationArray() {
    const authorizationsOption = {};

    Object.values(Applications).forEach(key => {
        authorizationsOption[key] = [];
    });

    return authorizationsOption;
}
